import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "onClose", "anchorRef", "style", "children", "className"];
import React, { forwardRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { cnBem } from '@carnica/utils';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { BottomSheet } from "../../../modules/BottomSheet";
import { Popover } from "../../../modules/Popover";
import styles from "./styles.pcss";
var varinats = {
  hidden: {
    poinerEvents: 'none',
    y: '12px',
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    poinerEvents: 'all'
  }
};
var cnCalendarWrapper = cnBem('wrapper', styles);
export var CalendarWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpen = props.isOpen,
    onClose = props.onClose,
    anchorRef = props.anchorRef,
    style = props.style,
    children = props.children,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isMobile = useIsMobileDimension();
  if (isMobile) {
    return /*#__PURE__*/React.createElement(BottomSheet, _extends({}, otherProps, {
      className: cnCalendarWrapper(null, [className]),
      closeOptions: {
        overlay: true
      },
      isOpen: isOpen,
      onClose: onClose,
      ref: ref,
      "data-t-id": "DatePicker-CalendarWrapper"
    }), children);
  }
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: isOpen,
    initial: false,
    mode: "wait",
    onExitComplete: function onExitComplete() {
      return null;
    }
  }, isOpen && /*#__PURE__*/React.createElement(Popover, _extends({}, otherProps, {
    anchorRef: anchorRef,
    animate: "visible",
    "aria-modal": "true",
    className: cnCalendarWrapper(null, [className]),
    direction: "downStartLeft",
    exit: "hidden",
    initial: "hidden",
    motion: true,
    offsetVertical: 18,
    onClickOutside: onClose,
    possibleDirections: ['downStartLeft', 'upStartLeft'],
    role: "dialog",
    transition: {
      transform: {
        duration: 0.3
      },
      opacity: {
        duration: 0.3
      }
    },
    variants: varinats
  }), children));
});